import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SpinnerService } from "@estatex/services";

@Component({
    selector: "lib-spinner",
    standalone: true,
    imports: [CommonModule],
    templateUrl: "./spinner.component.html",
    styleUrl: "./spinner.component.css",
})
export class SpinnerComponent {
    constructor(private spinnerService: SpinnerService) {}
    $loading = this.spinnerService.isLoading$;
}
